import { Logger as clientLogger } from 'beaver-logger'
const logUtil = {}

const logger = clientLogger({
  url: '/dashboard/log',
  logLevel: 'debug',
})

logUtil.info = function (name, data) {
  logger.info(name, data)
}

logUtil.log = function (name, data) {
  logger.info(name, data)
}

logUtil.error = function (name, data) {
  logger.error(name, data)
}

logUtil.track = function (data) {
  logger.track(data)
}

export default logUtil
